


























































































































































































import { IDepartureDate } from '@/store/models';
import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import EnquireForm from './EnquireForm.vue';

@Component
export default class EnquireFormSmall extends EnquireForm {
    @Prop({ type: String, default: 'Tour Page Top Enquire Form' }) protected readonly gtmCategory: string;

    protected autoExpand: boolean = false;

    protected clickedNext: boolean = false;

    protected clickedSubmit: boolean = false;

    public tooltipOps(field: string): any {
        const isTourValidation = ['destination', 'tour', 'date', 'airport', 'adults', 'children'].indexOf(field) > -1;
        let isTypeCorrepondToPage = false;
        if (this.clickedNext && isTourValidation && this.stepId !== this.STEP_PERSONAL_INFO) {
            isTypeCorrepondToPage = true;
        } else if (this.clickedSubmit && !isTourValidation && this.stepId === this.STEP_PERSONAL_INFO) {
            isTypeCorrepondToPage = true;
        }

        return {
            enabled: !this.isMobileViewportSize,
            content: this.errors[field],
            classes: 'c-tooltip--error',
            show: isTypeCorrepondToPage && this.errors[field] !== '',
            trigger: 'manual',
            autoHide: false,
            hideOnTargetClick: false,
            placement: 'left',
            offset: 5,
        };
    }

    protected onExternalDateSet(date: number | null): void {
        if (date === null) {
            this.innerDate = null;
            this.defaultFocusedInput = 'date';
        } else {
            const value = moment(date).format('YYYY-MM-DD');
            const targetDate: IDepartureDate | null = this.dates.find((d) => d.value === value) || null;
            this.defaultFocusedInput = null;
            this.innerDate = targetDate !== null ? targetDate.id : null;
        }
        this.combinationId = 0;
        this.airportId = null;
    }

    protected validateAndStepForward(): void {
        if (!this.clickedNext) {
            this.clickedNext = true;
        }
        if (this.errors.destination !== '' || this.errors.tour !== '' || this.errors.date !== ''
            || this.errors.airport !== '') {
            this.showTourValidation = true;
        } else {
            this.stepId = this.STEP_PERSONAL_INFO;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EnquireFormSmall.vue